import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogArticles } from '../data/blogArticles';
import { getSlug } from '../lib/blog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogSection = () => {
  // Start with the bundled snapshot so the list is present on first paint
  // (SEO / crawler-prerender friendly), then refresh from the live API.
  const [articles, setArticles] = useState(blogArticles);

  useEffect(() => {
    let active = true;
    fetch(`${API}/blog`)
      .then((res) => res.json())
      .then((data) => {
        if (active && Array.isArray(data.articles) && data.articles.length > 0) {
          setArticles(data.articles);
        }
      })
      .catch((err) => console.error('Blog fetch error:', err));
    return () => {
      active = false;
    };
  }, []);

  return (
    <section id="blog" className="py-20 lg:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6 text-center uppercase tracking-wide" data-testid="blog-heading">
            Blogartikel
          </h2>
          <p className="text-lg text-slate-600 mb-16 text-center leading-relaxed">
            Aktuelle Einblicke und Fachwissen rund um Versandlogistik und Briefkonsolidierung
          </p>

          {articles.length === 0 ? (
            <div className="text-center py-12 text-slate-500" data-testid="blog-empty">
              <p>Neue Artikel folgen in Kürze.</p>
            </div>
          ) : (
            <div className="space-y-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/blog/${getSlug(article)}`}
                  className="block bg-white/80 backdrop-blur-sm rounded-lg border border-slate-200 p-8 shadow-lg hover:shadow-xl transition-all duration-300 group"
                  data-testid={`blog-card-${article.id}`}
                >
                  <h3 className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-slate-700 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed mb-4">
                    {article.summary}
                  </p>
                  <span className="inline-flex items-center text-sm font-medium text-slate-800 group-hover:text-slate-600 transition-colors">
                    Weiterlesen
                    <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
